import { createFileRoute, redirect } from '@tanstack/react-router';
import { ResumeCard } from '@/components/ResumeCard';
import { ResumeContextCard } from '@/components/ResumeContextCard';
import { JobPreferencesForm } from '@/components/dashboard/JobPreferencesForm';
import { waitForClerk } from '@/utils/clerk';

export const Route = createFileRoute('/dashboard/profile')({
  component: ProfileContent,
  beforeLoad: async () => {
    // Wait for Clerk to load
    const user = await waitForClerk();
    if (!user) {
      return redirect({
        to: '/',
        replace: true,
      });
    }
  },
});

function ProfileContent() {
  return (
    <div className='grid grid-cols-1 md:grid-cols-2 gap-6'>
      <div className='space-y-6'>
        <ResumeCard />
        <ResumeContextCard />
      </div>
      <div>
        <JobPreferencesForm />
      </div>
    </div>
  );
}
